import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

export default function PaymentFailPage() {
  const [searchParams] = useSearchParams();
  const [code, setCode] = useState('');
  const [message, setMessage] = useState('');
  const [orderId, setOrderId] = useState('');

  useEffect(() => {
    const errorCode = searchParams.get('code');
    const errorMessage = searchParams.get('message');
    const errorOrderId = searchParams.get('orderId');

    setCode(errorCode);
    setMessage(errorMessage);
    setOrderId(errorOrderId);
  }, [searchParams]);

  return (
    <div>
      <p>
        <span>실패화면</span>
        <span>
          {code}, {message}, {orderId}
        </span>
      </p>
    </div>
  );
}
